import { AuthType, LogoutInfo, TokenInfo } from '@/models';
import { fetchWithHeaders, RequestResult, requestWrapper } from '@/api';

type AuthParams = {
  url: string;
  body: string;
  authType: AuthType;
};

type RefreshTokenParams = Omit<AuthParams, 'body'> & { token: string };

type LogoutParams = Omit<AuthParams, 'body'>;

export class AuthApi {
  static async signIn(params: AuthParams): Promise<RequestResult<TokenInfo>> {
    const { authType, body, url } = params;

    const request = () =>
      fetch(url, {
        method: 'post',
        headers: {
          'X-IdentityProvider': authType,
        },
        credentials: 'include',
        body,
      });

    return await requestWrapper(request, 'Failed to sign in');
  }

  static async refreshToken(params: RefreshTokenParams): Promise<RequestResult<TokenInfo>> {
    const { url, token, authType } = params;

    const request = () =>
      fetch(url, {
        method: 'post',
        headers: {
          'X-IdentityProvider': authType,
          Authorization: `Bearer ${token}`,
        },
        credentials: 'include',
      });

    return await requestWrapper(request, 'Failed to refresh token');
  }

  static async logout(params: LogoutParams): Promise<RequestResult<LogoutInfo>> {
    const { url, authType } = params;

    const request = () =>
      fetchWithHeaders(url, {
        method: 'post',
        headers: {
          'X-IdentityProvider': authType,
        },
        credentials: 'include',
      });

    return await requestWrapper(request, 'Failed to sign out');
  }
}
